var oddFlags = { 'GB': 'uk' };
export var getCountryFlag = function (countryCode) {
    var flatCode = oddFlags[countryCode] || countryCode.toLowerCase();
    return "flag-".concat(flatCode);
};
